export abstract class Logger {
  horse: any;
  dog: any;
  info: any;
  log: any;
  error: any;
  warn: any;
}

export class LoggerService implements Logger {
  horse: any;
  dog: any;
  info: any;
  log: any;
  warn: any;
  error: any;
}
